import { defineStore } from 'pinia'

interface Props {
    visible: boolean
}

export const useTabbarStore = defineStore({
    id: 'tabbar',
    state: (): Props => ({
        visible: false
    }),
    actions: {
        show() {
            this.visible = true
        },
        hide() {
            this.visible = false
        },
        toggle() {
            this.visible = !this.visible
        }
    }
})
